import type { jsPDF } from 'jspdf';

const ICON_VIEW_BOX_SIZE = 16;

const SEGMENT_REGEX = /([MLCZ])([^MLCZ]*)/g;
const NUMBER_REGEX = /-?\d*\.?\d+/g;

interface DrawPdfIconParams {
  doc: jsPDF;
  paths: string[];
  x: number;
  y: number;
  size: number;
  color: string;
  strokeWidth?: number;
}

export const drawPdfIcon = ({
  doc,
  paths,
  x,
  y,
  size,
  color,
  strokeWidth,
}: DrawPdfIconParams): void => {
  const scale = size / ICON_VIEW_BOX_SIZE;
  const points = (values: string) =>
    (values.match(NUMBER_REGEX) ?? []).map((value, index) =>
      index % 2 === 0 ? x + Number(value) * scale : y + Number(value) * scale,
    );

  if (strokeWidth) {
    doc.setDrawColor(color);
    doc.setLineWidth(strokeWidth * scale);
    doc.setLineCap('round');
    doc.setLineJoin('round');
  } else {
    doc.setFillColor(color);
  }

  paths.forEach((path) => {
    for (const [, command, values] of path.matchAll(SEGMENT_REGEX)) {
      const [
        first = 0,
        second = 0,
        third = 0,
        fourth = 0,
        fifth = 0,
        sixth = 0,
      ] = points(values);

      if (command === 'M') {
        doc.moveTo(first, second);
      }

      if (command === 'L') {
        doc.lineTo(first, second);
      }

      if (command === 'C') {
        doc.curveTo(first, second, third, fourth, fifth, sixth);
      }

      if (command === 'Z') {
        doc.close();
      }
    }

    if (strokeWidth) {
      doc.stroke();
    } else {
      doc.fill();
    }
  });

  doc.setLineCap('butt');
  doc.setLineJoin('miter');
};
